const Q = require(`q`);
const _ = require(`underscore`);
const __request = require(`./__request/__request_contentType_json`);

// 火车票订单详情接口文档地址：http://192.168.0.13:9900/doc.html#/trains/buyer-order-controller/getBuyerOrderDetailUsingPOST
const trains_buyerOrder_getBuyerOrderDetail = (pParameter) => {
  if (!pParameter) pParameter = {};

  const p = {
    method: 'post',
    urlSuffix: '/trains/buyerOrder/getBuyerOrderDetail',
    data: pParameter,
  };
  return Q.when()
    .then(function () {
      return __request(p);
    })
    .then(function (data) {
      return Q.resolve(data);
    })
    .catch(function (ex) {
      console.error(ex);
      if (ex) {
        if (ex.stack) {
          console.error(ex.stack);
        }
      }
      return Q.reject(ex);
    })
    ;
};
module.exports = trains_buyerOrder_getBuyerOrderDetail;
